import {
	AccountTree,
	AddCircleOutline,
	Assessment,
	CalendarToday,
	EmojiEvents,
	NotificationsActive,
	PeopleAlt,
	PhoneAndroid,
	Poll,
	Style,
} from "@material-ui/icons";

export const ADMIN_TOOLS = [
	{
		id: "event-create",
		title: "Event Creator",
		description: "Create events using an easy interface.",
		path: "/admin/event/create",
		icon: AddCircleOutline,
		category: "Events",
		roles: ["Admin", "EventCreator"],
	},
	{
		id: "event-format",
		title: "Event Format Builder",
		description: "Create and edit event formats.",
		path: "/admin/eventFormatBuilder",
		icon: AccountTree,
		category: "Events",
		roles: ["Admin"],
	},
	{
		id: "season",
		title: "Season Manager",
		description: "View season health and manage tournament seasons.",
		path: "/admin/season",
		icon: CalendarToday,
		category: "Events",
		roles: ["Admin"],
	},
	{
		id: "pickdata",
		title: "Pick Data",
		description: "View pick data for events.",
		path: "/admin/pickdata",
		icon: Assessment,
		category: "Events",
		roles: ["Admin"],
	},
	{
		id: "trophies",
		title: "Reward Trophies",
		description: "Reward users with their trophies for an event.",
		path: "/admin/giveTrophy",
		icon: EmojiEvents,
		category: "Events",
		roles: ["Admin", "EventCreator"],
	},
	{
		id: "user",
		title: "User Manager",
		description: "Manage user roles and access.",
		path: "/admin/user",
		icon: PeopleAlt,
		category: "Community",
		roles: ["Admin"],
	},
	{
		id: "survey",
		title: "Surveys",
		description: "Add/edit surveys and view results.",
		path: "/admin/survey",
		icon: Poll,
		category: "Community",
		roles: ["Admin", "SurveyCreator"],
	},
	{
		id: "notifications",
		title: "Push notifications",
		description: "Stats and send web push notifications.",
		path: "/admin/notifications",
		icon: NotificationsActive,
		category: "Community",
		roles: ["Admin"],
	},
	{
		id: "nameplate",
		title: "Nameplate Editor",
		description: "Create and edit nameplates.",
		path: "/admin/nameplate",
		icon: Style,
		category: "Configuration",
		roles: ["Admin"],
	},
	{
		id: "mobile",
		title: "Mobile Settings",
		description: "Configure mobile-related behavior.",
		path: "/admin/mobile-settings",
		icon: PhoneAndroid,
		category: "Configuration",
		roles: ["Admin"],
	},
];

export const CATEGORY_ORDER = ["Events", "Community", "Configuration"];

export function visibleTools(roles) {
	if (!roles) {
		return [];
	}
	return ADMIN_TOOLS.filter((tool) => tool.roles.some((role) => roles.includes(role)));
}

export function groupByCategory(tools) {
	return CATEGORY_ORDER.map((category) => ({
		category,
		tools: tools.filter((tool) => tool.category === category),
	})).filter((group) => group.tools.length > 0);
}

const RECENT_KEY = "pickstop.admin.recentTools";
const RECENT_LIMIT = 3;

function readRecentIds() {
	try {
		const raw = window.localStorage.getItem(RECENT_KEY);
		return raw ? JSON.parse(raw) : [];
	} catch (e) {
		return [];
	}
}

export function recordToolUse(id) {
	try {
		const next = [id, ...readRecentIds().filter((existing) => existing !== id)].slice(0, RECENT_LIMIT);
		window.localStorage.setItem(RECENT_KEY, JSON.stringify(next));
	} catch (e) {
		// ignore storage failures
	}
}

export function getRecentTools(tools) {
	const byId = {};
	tools.forEach((tool) => {
		byId[tool.id] = tool;
	});
	return readRecentIds()
		.slice(0, RECENT_LIMIT)
		.map((id) => byId[id])
		.filter(Boolean);
}
